import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { DEFAULT_MAX_ATTEMPTS, RETRY_MODES } from "./config";
import { DEFAULT_RETRY_DELAY_BASE, INITIAL_RETRY_TOKENS, NO_RETRY_INCREMENT, RETRY_COST, THROTTLING_RETRY_DELAY_BASE, TIMEOUT_RETRY_COST } from "./constants";
import { getDefaultRetryBackoffStrategy } from "./defaultRetryBackoffStrategy";
import { createDefaultRetryToken } from "./defaultRetryToken";
export var StandardRetryStrategy = /*#__PURE__*/function () {
  function StandardRetryStrategy(maxAttempts) {
    _classCallCheck(this, StandardRetryStrategy);
    this.maxAttempts = maxAttempts;
    this.mode = RETRY_MODES.STANDARD;
    this.capacity = INITIAL_RETRY_TOKENS;
    this.retryBackoffStrategy = getDefaultRetryBackoffStrategy();
    this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", maxAttempts);
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }
  _createClass(StandardRetryStrategy, [{
    key: "acquireInitialRetryToken",
    value: function () {
      var _acquireInitialRetryToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(retryTokenScope) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", createDefaultRetryToken({
                  retryDelay: DEFAULT_RETRY_DELAY_BASE,
                  retryCount: 0
                }));
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function acquireInitialRetryToken(_x) {
        return _acquireInitialRetryToken.apply(this, arguments);
      }
      return acquireInitialRetryToken;
    }()
  }, {
    key: "refreshRetryTokenForRetry",
    value: function () {
      var _refreshRetryTokenForRetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(token, errorInfo) {
        var maxAttempts, errorType, delayFromErrorType, retryDelay, capacityCost;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getMaxAttempts();
              case 2:
                maxAttempts = _context3.sent;
                if (!this.shouldRetry(token, errorInfo, maxAttempts)) {
                  _context3.next = 11;
                  break;
                }
                errorType = errorInfo.errorType;
                this.retryBackoffStrategy.setDelayBase(errorType === "THROTTLING" ? THROTTLING_RETRY_DELAY_BASE : DEFAULT_RETRY_DELAY_BASE);
                delayFromErrorType = this.retryBackoffStrategy.computeNextBackoffDelay(token.getRetryCount());
                retryDelay = errorInfo.retryAfterHint ? Math.max(errorInfo.retryAfterHint.getTime() - Date.now() || 0, delayFromErrorType) : delayFromErrorType;
                capacityCost = this.getCapacityCost(errorType);
                this.capacity -= capacityCost;
                return _context3.abrupt("return", createDefaultRetryToken({
                  retryDelay: retryDelay,
                  retryCount: token.getRetryCount() + 1,
                  retryCost: capacityCost
                }));
              case 11:
                throw new Error("No retry token available");
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function refreshRetryTokenForRetry(_x2, _x3) {
        return _refreshRetryTokenForRetry.apply(this, arguments);
      }
      return refreshRetryTokenForRetry;
    }()
  }, {
    key: "recordSuccess",
    value: function recordSuccess(token) {
      var _token$getRetryCost;
      this.capacity = Math.max(INITIAL_RETRY_TOKENS, this.capacity + ((_token$getRetryCost = token.getRetryCost()) !== null && _token$getRetryCost !== void 0 ? _token$getRetryCost : NO_RETRY_INCREMENT));
    }
  }, {
    key: "getCapacity",
    value: function getCapacity() {
      return this.capacity;
    }
  }, {
    key: "getMaxAttempts",
    value: function () {
      var _getMaxAttempts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.maxAttemptsProvider();
              case 3:
                return _context4.abrupt("return", _context4.sent);
              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                console.warn("Max attempts provider could not resolve. Using default of ".concat(DEFAULT_MAX_ATTEMPTS));
                return _context4.abrupt("return", DEFAULT_MAX_ATTEMPTS);
              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6]]);
      }));
      function getMaxAttempts() {
        return _getMaxAttempts.apply(this, arguments);
      }
      return getMaxAttempts;
    }()
  }, {
    key: "shouldRetry",
    value: function shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
      var attempts = tokenToRenew.getRetryCount() + 1;
      return attempts < maxAttempts && this.capacity >= this.getCapacityCost(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
    }
  }, {
    key: "getCapacityCost",
    value: function getCapacityCost(errorType) {
      return errorType === "TRANSIENT" ? TIMEOUT_RETRY_COST : RETRY_COST;
    }
  }, {
    key: "isRetryableError",
    value: function isRetryableError(errorType) {
      return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
  }]);
  return StandardRetryStrategy;
}();